import { Constructor } from '@angular/cdk/table';


/**
 * BaseViewAnimationTrait
 *
 * Viewの基底クラス
 * アニメーション処理の分割クラス
 */
// export abstract class BaseViewAnimationTrait extends RailgunBase {
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function BaseViewAnimationTrait<T extends Constructor<{}>>(Target: T) {
return class extends Target {

	// フェードアニメーションの状態を管理するパラメータ
	// バインドされてるパラメータを変化させると、アニメーションが起動する。
	public animationFadeState = 'fadeIn';

	// スライドイン・アウトの状態を管理するパラメータ
	// バインドされてるパラメータを変化させると、アニメーションが起動する。
	public animationSlideState = 'slideOut'; // 初期値 slideOut=いない  slideIn=いる

	/**
	 * toggleFade
	 * フェードイン・アウト
	 * 呼ぶたびに切り替わる
	 */
	public toggleFade() { // バインドされてるパラメータを変化させると、アニメーションが起動する。
		this.animationFadeState = this.animationFadeState === 'fadeIn' ? 'fadeOut' : 'fadeIn';
	}

	/**
	 * toggleFade
	 * スライドイン・アウト
	 * 呼ぶたびに切り替わる
	 */
	public toggleSlide() {// バインドされてるパラメータを変化させると、アニメーションが起動する。
		this.animationSlideState = this.animationSlideState === 'slideIn' ? 'slideOut' : 'slideIn';
	}
	public slideIn() { // スライドイン単体
		this.animationSlideState = 'slideIn';
	}
	public slideOut() { // スライドアウト単体
		this.animationSlideState = 'slideOut';
	}

};
}
